import { ProductDataSource } from "../../dataProcess/productDataSource";

export class Brand {
  constructor(
    public id?: string,
    public name?: string,
    public description?: string,
    public website?: string,
    public logoFile?: string,
    public dataSources?: string[]
  ) {}

  equals(other: Brand): boolean {
    if (!other) return false;

    return (
      this.id === other.id &&
      this.name === other.name &&
      this.description === other.description &&
      this.website === other.website &&
      this.logoFile === other.logoFile &&
      Brand.setEquals(this.dataSources, other.dataSources)
    );
  }

  private static setEquals(a?: string[], b?: string[]): boolean {
    if (a === b) return true; 
    if (!a || !b) return false;

    const setA = new Set(a );
    const setB = new Set(b );

    if (setA.size !== setB.size) return false;

    for (const val of setA) {
      if (!setB.has(val)) return false;
    }
    return true;
  }
}
